import { useEffect, useRef, useState } from "react"
import { useTranslation } from "react-i18next"
import { Box } from "@mui/material"
import { useAppSelector, useAppDispatch } from "@/core/app/hooks"
import { RootState } from "@/core/app/store"
import FormControlLabel from "@mui/material/FormControlLabel"
import Checkbox from "@mui/material/Checkbox"
import Radio from "@mui/material/Radio"
import RadioGroup from "@mui/material/RadioGroup"
import FormControl from "@mui/material/FormControl"
import FormLabel from "@mui/material/FormLabel"
export const StageNumber = () => {
  const {
    clinicalSettings: {
      LabelStagingNumber,
      LabelStagingNumberStart,
      StageNumberLeftOrRight,
    },
  } = useAppSelector((state: RootState) => state.userService)
  const dispatch = useAppDispatch()
  // checkbox if No stage
  const [checkNoStage, setCheckNoStage] = useState<boolean>(false)
  const handleCheck = (event: React.ChangeEvent<HTMLInputElement>) => {
    setCheckNoStage(event.target.checked)
  }
  // tooth number
  const [toothNumber, setToothNumber] = useState<string>("")
  const handleToothNumber = (event: React.ChangeEvent<HTMLInputElement>) => {
    setToothNumber((event.target as HTMLInputElement).value)
  }

  // side number
  const [sideNumber, setSideNumber] = useState<string>("")
  const handleSideNumber = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSideNumber((event.target as HTMLInputElement).value)
  }
  // init tabs value
  useEffect(() => {
    if (LabelStagingNumber === "StageNo") {
      setCheckNoStage(true)
    }

    if (LabelStagingNumberStart !== "" && StageNumberLeftOrRight !== "") {
      let direction = ""
      if (StageNumberLeftOrRight) {
        direction = "left"
      } else {
        direction = "right"
      }
      setToothNumber(`${LabelStagingNumberStart}-${direction}`)
    }

    if (LabelStagingNumber !== "StageNo") {
      setSideNumber(LabelStagingNumber)
    }
  }, [])
  return (
    <Box sx={{ width: "100%" }}>
      <FormControlLabel
        control={<Checkbox checked={checkNoStage} onChange={handleCheck} />}
        label="No Stage Number on the model"
        sx={{ margin: "0 0 10px 0" }}
      />
      <Box sx={{ width: "100%", display: "flex" }}>
        <FormControl sx={{ marginRight: "80px" }} disabled={checkNoStage}>
          <FormLabel id="toothNumber">{`Select the tooth to place stage number`}</FormLabel>
          <RadioGroup
            sx={{ marginLeft: "10px" }}
            aria-labelledby="toothNumber"
            name="radio-buttons-group"
            value={toothNumber}
            onChange={handleToothNumber}
          >
            <FormControlLabel
              value="Second_Premolar-left"
              control={<Radio />}
              label="Left 2nd. premolar"
            />
            <FormControlLabel
              value="First_Molar-left"
              control={<Radio />}
              label="Left 1st. molar"
            />
            <FormControlLabel
              value="Second_Premolar-right"
              control={<Radio />}
              label="Right 2nd. premolar"
            />
            <FormControlLabel
              value="First_Molar-right"
              control={<Radio />}
              label="Right 1st. molar"
            />
          </RadioGroup>
        </FormControl>
        <FormControl disabled={checkNoStage}>
          <FormLabel id="sideNumber">{`Select the side to place stage number`}</FormLabel>
          <RadioGroup
            sx={{ marginLeft: "10px" }}
            aria-labelledby="sideNumber"
            name="radio-buttons-group"
            value={sideNumber}
            onChange={handleSideNumber}
          >
            <FormControlLabel
              value="Buccal"
              control={<Radio />}
              label="Buccal side of the tooth"
            />
            <FormControlLabel
              value="Lingual"
              control={<Radio />}
              label="Lingual side of the tooth"
            />
          </RadioGroup>
        </FormControl>
      </Box>
    </Box>
  )
}
